import { Link } from '@components'
import { TMaterial } from '@typings'
import React from 'react'

const sorter = () => 0

export const columns = [
	{
		title: 'Id',
		dataIndex: 'id',
		width: 142,
		searchKey: 'id',
		align: 'center',
		fixed: 'left',
		sorter,
		render: (text: string, record: TMaterial) => <Link to={`/materials/${record.id}`}>{text}</Link>,
	},
	{
		title: 'Title',
		dataIndex: 'title',
		width: 200,
		searchKey: 'title',
	},
]
